// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"73b40812","344":"cd53456a","788":"0454d10e","970":"20cfe87e"}[chunkId] + ".chunk.js";
};